import { render, staticRenderFns } from "./SidBarGame.vue?vue&type=template&id=2a0d3f58&scoped=true"
import script from "./SidBarGame.vue?vue&type=script&lang=js"
export * from "./SidBarGame.vue?vue&type=script&lang=js"
import style0 from "./SidBarGame.vue?vue&type=style&index=0&id=2a0d3f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d3f58",
  null
  
)

export default component.exports